jQuery(function ($) {

    tippy('.poi__trigger', {
        trigger: 'click',
        animation: 'shift',
        arrow: true,
        theme: 'ni',
        interactive: true,
        arrowSize: 'big',
        onShow: function () {
            $(this).find('*[data-src].poi__image').responsiveLazyLoader({
                force: true
            });
        },
        popperOptions: {
            modifiers: {
                flip: {
                    enabled: false
                }
            }
        }
    });

    $(window).on('scroll', Util.throttle(function () {
        $('.poi__trigger').each(function () {
            var poi = $(this),
                poiContainer = poi.parent();

            if (Util.isInViewport(poi) && !poiContainer.hasClass('loaded')) {
                poiContainer.addClass('loaded');
            }
        });
    }, 100));

    function initSlider () {
        $('.poi-gallery')
            .slick({
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 0,
                speed: 300,
                accessibility: true,
                lazyLoad: 'ondemand',
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><span></span></button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><span></span></button>',
            })
            .on('setPosition', function () {
                // arrow position calculation
                var elm = $(this),
                    slideImageHeight = elm.find('.slick-track .slick-slide:nth-child(2) img').height(),
                    slideArrowBox = elm.find('.slick-prev span').height(),
                    slideArrowBoxDistance = slideImageHeight / 2 - slideArrowBox / 2;
                elm.find('.slick-prev span, .slick-next span').css('top', slideArrowBoxDistance);
            })
            .on('beforeChange', function () {
                // load all images on first user event
                var lazyImages = $(this).find('img[data-lazy]'),
                    lazyImageCount = lazyImages.length;
                if (lazyImageCount > 0) {
                    lazyImages.each(function () {
                        $(this).attr('src', $(this).attr('data-lazy'))
                            .removeAttr('data-lazy')
                            .removeClass('slick-loading');
                    });
                }
            })
            .on('swipe', function (event, slick, direction) {
                Track.analyticsEvent('Product Page', 'Swipe POI gallery', 'to-slide-' + slick.currentSlide, direction);
            });
    };

    var galleryImages = $('.poi-gallery .poi-slice img.lazy-gallery');

    if(galleryImages.length){
        galleryImages.responsiveLazyLoader({

            force: true, // target image is rendered into data-src which is moved to src by slick on demand

            initialized: function () {

                // perform actions when image was loaded
                $('.poi-gallery img.lazy-gallery')
                    .one('load', function () {
                        $(this).parent().removeClass('spinner');
                        // adjust height after lazy loading - slick has problems to trigger this when calling a page by ajax
                        $(this).parents('.poi-gallery').get(0).slick.animateHeight();
                        $(this).parents('.poi-gallery').get(0).slick.setPosition();
                    });

                // init slick galleries
                initSlider();

            }
        });
    } else {
        $('.poi-gallery .poi-slice').removeClass('spinner').addClass('no-image');
    }


});
